import React, { useEffect, useState } from 'react'
import JobCard from '../JobPages/JobCard'
import axios from 'axios'

const JobSlider = () => {

    const [jobs, setJobs] = useState([])

    useEffect(() => {

        const getJobs = async () => {
            try {
                const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getalljobs`)

                console.log(data.data);
                setJobs(data.data);
                // setAllProducts(data.data);
            }
            catch (error) { console.log('There was an error getting the products!', error); }
        }

        getJobs();

    }, [])


    return (
        <div className='flex flex-col py-16 gap-12'>

            <div className='px-16 font-semibold text-[28px] text-center'>
                Top Companies Hiring Right Now
            </div>

            <div className='px-0 overflowScroll flex gap-5 py-4'>
                {jobs?.length > 0 && jobs?.map((job) => {
                    return (
                        <JobCard key={job._id} job={job} />
                    )
                })
                }
            </div>

        </div>
    )
}

export default JobSlider